export const Breakpoint = {
  Tablet: `only screen and (max-width: 1024px)`,
  Phone: `only screen and (max-width: 480px)`
}
